import { addonsModalsContent } from '@web/components/AddOnQuickView/constants';
import beefImage from '../../images/our-food/rebrandBeef.jpg';
import {
  ADDON_SKUS as addonSkus,
  supplementsDropdownsAndValues,
  treatsDropdownsAndValues,
} from '../../testing/constants';

export const addons = [
  {
    sku: addonSkus.zoomies,
    description: 'Some Description',
    title: 'Zoomies',
    productType: 'TR',
    subtitle: 'Soft Chew Treats',
    size: '1 bag (5oz.)',
    pricingInfo: {
      price: '{{addonPrice}}',
      discountedPrice: '{{addonDiscount}}',
    },
    image: {
      src: beefImage.src,
      alt: 'Beef Recipe Image',
      width: beefImage.width,
      height: beefImage.height,
    },
    dropdowns: treatsDropdownsAndValues.dropdowns,
  },
  {
    sku: addonSkus.turkeyjerky,
    title: 'Chill Pills',
    productType: 'TR',
    description: 'Some Description',
    subtitle: 'Soft Chew Treats',
    size: '1 bag (5oz.)',
    pricingInfo: {
      price: '{{addonPrice}}',
      discountedPrice: '{{addonDiscount}}',
    },
    image: {
      src: beefImage.src,
      alt: 'Beef Recipe Image',
      width: beefImage.width,
      height: beefImage.height,
    },
    dropdowns: treatsDropdownsAndValues.dropdowns,
  },
  {
    sku: addonSkus.beefjerky,
    title: 'Beef Jerky',
    productType: 'TR',
    description: 'Some Description',
    subtitle: 'Soft Chew Treats',
    size: '1 bag (5oz.)',
    pricingInfo: {
      price: '{{addonPrice}}',
      discountedPrice: '{{addonDiscount}}',
    },
    image: {
      src: beefImage.src,
      alt: 'Beef Recipe Image',
      width: beefImage.width,
      height: beefImage.height,
    },
    dropdowns: treatsDropdownsAndValues.dropdowns,
  },
  {
    sku: addonSkus.bellyrubs,
    title: 'Belly Rubs',
    productType: 'SP',
    subtitle: 'Soft Chew Treats',
    description: 'Some Description',
    size: '1 bag (5oz.)',
    pricingInfo: {
      price: '{{addonPrice}}',
      discountedPrice: '{{addonDiscount}}',
    },
    image: {
      src: beefImage.src,
      alt: 'Beef Recipe Image',
      width: beefImage.width,
      height: beefImage.height,
    },
    dropdowns: supplementsDropdownsAndValues.dropdowns,
  },
  {
    sku: 'Supplement 2',
    title: 'Just Chicken Strips',
    productType: 'SP',
    subtitle: 'Soft Chew Treats',
    description: 'Some Description',
    size: '1 bag (5oz.)',
    pricingInfo: {
      price: '{{addonPrice}}',
      discountedPrice: '{{addonDiscount}}',
    },
    image: {
      src: beefImage.src,
      alt: 'Beef Recipe Image',
      width: beefImage.width,
      height: beefImage.height,
    },
    dropdowns: supplementsDropdownsAndValues.dropdowns,
  },
];

export const addonFormProps = {
  headline: 'Choose Extras for your pup',
  subheadline: '',
  defaultAddons: [
    {
      sku: addonSkus.zoomies,
      title: 'Just Chicken Strips',
      productType: 'TR',
      subtitle: 'Soft Chew Treats',
      size: '1 bag (5oz.)',
      pricingInfo: {
        price: '{{addonPrice}}',
        discountedPrice: '{{addonDiscount}}',
      },
      quantity: 2,
      frequency: 2,
      image: {
        src: beefImage.src,
        alt: 'Beef Recipe Image',
        width: beefImage.width,
        height: beefImage.height,
      },
      dropdowns: treatsDropdownsAndValues.dropdowns,
    },
  ],
  addonSections: [
    {
      headline: 'Treats',
      addons: addons.slice(0, 3),
    },
    {
      headline: 'Supplements',
      addons: addons.slice(3, 5),
    },
  ],
  modals: addonsModalsContent.map(content => ({
    ...content,
    ...{
      pupInfo: {
        pupName: 'Panda',
        pupPronoun: 'him',
        addonServingFrequency: '2 weeks',
      },
    },
  })),
  unavailableAddons: [],
  onChange: () => {},
  onSubmit: () => {},
  cancelButtonText: 'Cancel',
  submitButtonText: 'Submit',
};

export const NOT_SELECTABLE_TEXT =
  'To choose this item, please remove one of your previous selections.';
